













































































import { Component, Vue } from "vue-property-decorator";
import { Field, Cell, Col, Row, Image, Lazyload, RadioGroup, Radio, Toast, Dialog， Button } from 'vant';
import { ErrorCode, ErrorInfo } from "@/network/http";
import { getQueryParam } from "@/utils/index";
import { VerifyCodeInfo, FundAccountInfo } from '@/data/local/account'

Vue.use(Field);
Vue.use(Cell);
Vue.use(Col);
Vue.use(Row);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Button);

@Component({})
export default class QueryFund extends Vue {
    url: string = "";
    inputType: string = "1";
    cerId: string = "";
    account: string = "";
    verifyCode: string = "";
    imgCodeData: VerifyCodeInfo | null = null;
    accountPlaceholderText: string = "个人公积金账号";
    queryLoading: boolean = false;
    showResult: boolean = false;
    resultData: FundAccountInfo | null = null;
    queryStateTxt: string = "查询成功";
    showDetailDialog: boolean = false;

    mounted() {
        this.url = decodeURI(getQueryParam(this.$route, "url"));
        this.refreshVCode();
    }

    get stateColor() {
        if (this.resultData && this.resultData.queryState === 1) {
            let state = this.resultData.accountState;
            if (state === '正常') {
                return "#228B22";
            }
        }
        return "#F75000";
    }

    changeType(name: string) {
        if (name === "1") {
            this.accountPlaceholderText = "个人公积金账号";
        } else {
            this.accountPlaceholderText = "个人社保电脑号";
        }
    }

    refreshVCode() {
        let lThis:any = this;
        lThis.$http.getVerifyCode(1, (errorInfo: ErrorInfo, data: VerifyCodeInfo | null) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                Toast("刷新验证码失败！");
            } else {
                this.imgCodeData = data;
            }
        });
    }

    submit() {
        this.queryStateTxt = "";

        let type = this.inputType;
        let certId = this.cerId;
        let account = this.account;
        let verifyCode = this.verifyCode;

        if (!type || !certId || !account || !verifyCode) {
            Toast("缺少参数！");
            return;
        }

        if (!this.imgCodeData || !this.imgCodeData.sid) {
            Toast("验证码过期！");
            return;
        }

        this.queryLoading = true;
        let lThis:any = this;
        lThis.$http.getFundAccount(1, parseInt(type), certId, account, verifyCode, this.imgCodeData.sid, (errorInfo: ErrorInfo, data: FundAccountInfo | null) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                Toast(errorInfo.msg);
                this.queryStateTxt = "查询失败";

            } else {
                this.resultData = data;

                if (data && data.queryState === 1) {
                    this.queryStateTxt = "查询成功";
                } else {
                    this.queryStateTxt = "查询失败";
                }
                this.showResult = true;
            }

            this.queryLoading = false;
            this.refreshVCode();
        });
    }

    toDetail() {
        this.showDetailDialog = true;
    }
}
